import React, { useCallback } from "react";
import { t } from "i18next";
import { BasicIcon } from "@pickit/pickit-components";
import { FirstPageProps } from "./types";
import "../operateTab.scss";

const FirstPage: React.FC<FirstPageProps> = ({ next, deliver, pickUp }) => {
  const options = [
    {
      label: t("PickUp:title"),
      page: pickUp,
    },
    {
      label: t("Deliver:title"),
      page: deliver,
    },
  ];

  const handleClick = useCallback(
    (page: string) => () => {
      next(page);
    },
    [next]
  );

  return (
    <div>
      {options.map((option, index) => (
        <button onClick={handleClick(option.page)} className="operate-option">
          <p>{option.label}</p>
          <BasicIcon name="chevron-right" clickable />
        </button>
      ))}
    </div>
  );
};

export default FirstPage;
